/**
 * Lab `/aggregateMembers/` modal password rules
 * (`passwordPattern` + detailForm error copy in aggregateMembers HTML).
 */

/** Lab `$scope.passwordPattern`. */
export const AGGREGATE_PASSWORD_RE =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,20}$/

/**
 * Lab password field error lines (`error-msg` under Password).
 * Joined single-line string kept for toast / unit asserts.
 */
export const AGGREGATE_PASSWORD_POLICY_LINES = [
  'Password should be atleast 8 characters and maximum 20 characters.',
  'It should contain',
  '1 alpha-numeric character',
  '1 upper case character',
  '1 lower case character',
  '1 special character.',
] as const

export const AGGREGATE_PASSWORD_POLICY_MESSAGE = [
  'Password should be atleast 8 characters and maximum 20 characters.',
  'It should contain 1 alpha-numeric character 1 upper case character 1 lower case character 1 special character.',
].join(' ')

export const AGGREGATE_CONFIRM_REQUIRED = 'Confirm Password is required.'
export const AGGREGATE_CONFIRM_MISMATCH = 'Password and confirm password do not match.'

export function isAggregatePasswordValid(password: string): boolean {
  return AGGREGATE_PASSWORD_RE.test(password)
}

/**
 * Password field invalid — create always requires a strong password;
 * edit only validates when the operator typed a new password.
 */
export function aggregatePasswordInvalid(
  password: string,
  opts: { editing: boolean },
): boolean {
  if (opts.editing && !password) return false
  if (!password) return true
  return !isAggregatePasswordValid(password)
}

/** Lab confirm validators: `required` + `compareTo` (both can show). */
export function aggregateConfirmPasswordErrors(
  password: string,
  confirm: string,
  opts: { editing: boolean },
): string[] {
  const required = !opts.editing || Boolean(password)
  const out: string[] = []
  if (required && !confirm) out.push(AGGREGATE_CONFIRM_REQUIRED)
  if (confirm || password) {
    if (password !== confirm) out.push(AGGREGATE_CONFIRM_MISMATCH)
  }
  return out
}

export function aggregatePasswordFormValid(input: {
  password: string
  confirmPassword: string
  editing: boolean
}): boolean {
  if (aggregatePasswordInvalid(input.password, { editing: input.editing })) {
    return false
  }
  return (
    aggregateConfirmPasswordErrors(input.password, input.confirmPassword, {
      editing: input.editing,
    }).length === 0
  )
}
